import { AlertTriangle, X } from 'lucide-react';

interface DeleteCustomerModalProps {
  customer: { id: string; name: string };
  onClose: () => void;
  onDelete: (customerId: string) => void;
}

export function DeleteCustomerModal({ customer, onClose, onDelete }: DeleteCustomerModalProps) {
  const handleDelete = () => {
    onDelete(customer.id);
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      ></div>

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-xl w-full max-w-md">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-gray-100">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-red-50 rounded-lg">
                <AlertTriangle className="w-5 h-5 text-red-600" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-gray-900">Delete Customer</h2>
              </div>
            </div>
            <button 
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <X className="w-5 h-5 text-gray-500" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-sm text-gray-600 mb-4">
              Are you sure you want to delete customer <span className="font-semibold text-gray-900">{customer.name}</span> ({customer.id})?
            </p>
            <p className="text-sm text-gray-600">
              This action cannot be undone. All customer data including order history will be permanently removed.
            </p>
          </div>

          {/* Buttons */}
          <div className="flex items-center gap-3 p-6 border-t border-gray-100">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors"
            >
              Delete Customer
            </button>
          </div>
        </div>
      </div>
    </>
  );
}